<!--
 * @Author: Lemon C
 * @Date: 2024-04-22 10:43:10
 * @LastEditTime: 2024-12-05 11:44:50
-->
<template>
    <div class="sup-bady">
        <div class="aaaaaa"></div>
        <div class="aaaaaa"></div>
        <div class="aaaaaa"></div>
        <div class="aaaaaa"></div>
    </div>
</template>

// MOD--  JavaScript
<script setup>
</script>

// MOD--  CSS
<style lang="less" scoped>
.sup-bady {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .aaaaaa {
        height: 600px;
        position: relative;
        margin: 200px;
        display: flex;
        flex-shrink: 0;
    }
}
</style>